import { defineMessages } from 'react-intl'

const scope =
  'procurify.modules.expense.GetExpenseMileageConfigurationPresenter'

export default defineMessages({
  loadErrorToastTitle: {
    id: `${scope}.loadErrorToastTitle`,
    defaultMessage: 'Error',
  },
  loadErrorToastMessage: {
    id: `${scope}.loadErrorToastMessage`,
    defaultMessage: 'Mileage configuration could not be loaded',
  },
})
